export const inputClassName = 'w-full px-3 py-2 border border-gray-300 rounded-md text-blue-700 font-bold';

export const authHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'ngrok-skip-browser-warning': 'true',
});

export const API_BASE = process.env.REACT_APP_API_URL;

export function formatSgDate(value) {
    if (!value) return '-';
    const d = new Date(value);
    if (!Number.isFinite(d.getTime())) return '-';
    return d.toLocaleDateString('en-SG');
}

export function formatSgDateTime(value) {
    if (!value) return '';
    const d = new Date(value);
    if (!Number.isFinite(d.getTime())) return '';
    return d.toLocaleString('en-SG');
}

export function toDateInputValue(value) {
    if (!value) return '';
    const d = new Date(value);
    if (!Number.isFinite(d.getTime())) return '';
    return d.toISOString().slice(0, 10);
}

export const emptyPaymentRow = () => ({
    currency: '',
    amount: '',
    paymentDate: '',
});

export const emptySubServerRow = () => ({
    name: '',
    type: '',
    status: '',
    loginID: '',
    loginPass: '',
    estMonthlyPaymentCurrency: '',
    estMonthlyPaymentAmount: '',
    domains: [],
});

const STATUS_ICON_MAP = {
    active: '✅',
    redirect: '↔️',
    'redirect web': '🌐',
    'redirect telegram': '✈️',
    blocked: '⛔️',
    holding: '⏸️',
    inactive: '❓',
};

export function formatAssetStatus(status) {
    if (!status) return '—';
    const key = String(status).trim().toLowerCase();
    const icon = STATUS_ICON_MAP[key];
    return icon ? `${status} ${icon}` : status;
}

export function boolTickClass(value) {
    return value ? 'text-green-600 font-bold' : 'text-red-500 font-bold';
}

export function boolTickChar(value) {
    return value ? '✓' : '✗';
}

export function formatDnsDisplay(dns, dnsAccount) {
    const left = dns || '';
    const right = dnsAccount || '';
    if (left && right) return `${left} - ${right}`;
    return left || right || '—';
}

export function formatDomainServerLinks(item) {
    const links = item?.serverLinks || [];
    if (links.length === 0) {
        const name = item?.server?.mainServerName;
        if (!name) return '—';
        const sub = item?.linkedSubServer?.name;
        return sub ? `${name} - ${sub}` : name;
    }
    return links.map((link) => {
        if (link.hasSubServer && link.subServerName) {
            return `${link.mainServerName} - ${link.subServerName}`;
        }
        return link.mainServerName || '—';
    }).join('\n');
}

export function formatServerPayment(item) {
    const payment = item?.paymentObject || {};
    const cardExpiry = [payment.cardExpiry?.month, payment.cardExpiry?.year].filter(Boolean).join('/');
    const parts = [];
    if (item?.needPayment) parts.push('✓');
    if (payment.paymentType) parts.push(payment.paymentType);
    if (payment.paymentCard) parts.push(payment.paymentCard);
    if (cardExpiry) parts.push(cardExpiry);
    return parts.length ? parts.join(' - ') : '—';
}

export function formatTelegramLabel(item) {
    if (!item) return '—';
    if (typeof item === 'string') return item;
    const parts = [];
    if (item.groupLink) parts.push(item.groupLink);
    if (item.community?.length) parts.push(`[${item.community.join(', ')}]`);
    if (item.type) parts.push(`(${item.type})`);
    return parts.join(' ') || item._id || '—';
}

export function formatDomainRedirectTarget(item) {
    if (!item?.redirectTo) return '—';
    const target = item.redirectTo;
    if (item.redirectToModel === 'TelegramAsset' || target.groupLink) {
        return formatTelegramLabel(target);
    }
    return target.domainURL || '—';
}
